import React, { Component } from "react";
import { IconBoxReusableSeatingComponent } from "./../../../../reusableComponents/IconBoxReusable/IconBoxReusableComponent";

export class MainAllPagesLink extends Component {
  render() {
    const pendingWhite = require("./../../../../../assets/images/seatingImages/emailWhite.png");
    const pendingDark = require("./../../../../../assets/images/seatingImages/emailBlack.png");
    const seatingWhite = require("./../../../../../assets/images/seatingImages/chairWhite.png");
    const seatingDark = require("./../../../../../assets/images/seatingImages/chairBlack.png");
    const reservationWhite = require("./../../../../../assets/images/seatingImages/reservationWhite.png");
    const reservationDark = require("./../../../../../assets/images/seatingImages/reservationBlack.png");
    const historyWhite = require("./../../../../../assets/images/seatingImages/historyWhite.png");
    const historyDark = require("./../../../../../assets/images/seatingImages/historyBlack.png");
    return (
      <React.Fragment>
        <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 seating-left-side-navigation">
          <div className="row">
            <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
              <div
                onClick={this.props.onClickPending}
                className="seating-icon-box-section text-decoration-none"
              >
                <div>
                  <div
                    className={
                      this.props.selectedPage === 2
                        ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                        : "seating-dashboard-reusable-button"
                    }
                  >
                    <span className="badge custom-icon-button-badge cutom-badge-position-pending">
                      {this.props.notificationCount === 0
                        ? 0
                        : this.props.notificationCount}
                    </span>

                    <img
                      src={
                        this.props.selectedPage === 2
                          ? pendingWhite
                          : pendingDark
                      }
                      alt="icon"
                      title="Pending Record"
                      className={`img-fluid inside-image-button`}
                    />
                  </div>
                  <p
                    className={
                      this.props.selectedPage === 2
                        ? "icon-bottom-text icon-bottom-text-active"
                        : "icon-bottom-text"
                    }
                  >
                    Pending
                  </p>
                </div>
              </div>
            </div>
            <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
              <div
                onClick={this.props.onClickSeating}
                className="seating-icon-box-section text-decoration-none"
              >
                <div>
                  <div
                    className={
                      this.props.selectedPage === 1
                        ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                        : "seating-dashboard-reusable-button"
                    }
                  >
                    <img
                      src={
                        this.props.selectedPage === 1
                          ? seatingWhite
                          : seatingDark
                      }
                      alt="icon"
                      title="Seating Record"
                      className={`img-fluid inside-image-button`}
                    />
                  </div>
                  <p
                    className={
                      this.props.selectedPage === 1
                        ? "icon-bottom-text icon-bottom-text-active"
                        : "icon-bottom-text"
                    }
                  >
                    Seating
                  </p>
                </div>
              </div>
            </div>
            <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 p-0 text-center">
              <div
                onClick={this.props.onClickReservation}
                className="seating-icon-box-section text-decoration-none"
              >
                <div>
                  <div
                    className={
                      this.props.selectedPage === 3
                        ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                        : "seating-dashboard-reusable-button"
                    }
                  >
                    <img
                      src={
                        this.props.selectedPage === 3
                          ? reservationWhite
                          : reservationDark
                      }
                      alt="icon"
                      title="Reservation Record"
                      className={`img-fluid inside-image-button`}
                    />
                  </div>
                  <p
                    className={
                      this.props.selectedPage === 3
                        ? "icon-bottom-text icon-bottom-text-active"
                        : "icon-bottom-text"
                    }
                  >
                    Reservations
                  </p>
                </div>
              </div>
            </div>
            <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
              <div
                onClick={this.props.onClickHistory}
                className="seating-icon-box-section text-decoration-none"
              >
                <div>
                  <div
                    className={
                      this.props.selectedPage === 4
                        ? "seating-dashboard-reusable-button seating-dashboard-reusable-button-active"
                        : "seating-dashboard-reusable-button"
                    }
                  >
                    <img
                      src={
                        this.props.selectedPage === 4
                          ? historyWhite
                          : historyDark
                      }
                      alt="icon"
                      title="History Record"
                      className={`img-fluid inside-image-button`}
                    />
                  </div>
                  <p
                    className={
                      this.props.selectedPage === 4
                        ? "icon-bottom-text icon-bottom-text-active"
                        : "icon-bottom-text"
                    }
                  >
                    History
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 p-0">
            <hr className="mobile-device-line" />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default MainAllPagesLink;
